import React from "react";
import { FormProvider, useForm } from "../context/FormContext";
import { Nav } from "../components/site/Nav";
import { MobileCTA } from "../components/site/MobileCTA";
import { Hero } from "../components/site/Hero";
import { WaysToUse } from "../components/site/WaysToUse";
import { Gallery } from "../components/site/Gallery";
import { Events } from "../components/site/Events";
import { Booking } from "../components/site/Booking";
import { AvailabilityForm } from "../components/site/AvailabilityForm";
import { FAQ } from "../components/site/FAQ";
import { FinalInvite } from "../components/site/FinalInvite";
import { Footer } from "../components/site/Footer";

function Sections() {
  const { formRef } = useForm();
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <WaysToUse />
        <Gallery />
        <Events />
        <Booking />
        <AvailabilityForm formRef={formRef} />
        <FAQ />
        <FinalInvite />
      </main>
      <Footer />
      <MobileCTA />
    </>
  );
}

export default function Landing() {
  return (
    <FormProvider>
      <Sections />
    </FormProvider>
  );
}
